import { render } from "./InstgramReelreviewcom.vue?vue&type=template&id=7b8b2201&scoped=true"
import script from "./InstgramReelreviewcom.vue?vue&type=script&lang=js"
export * from "./InstgramReelreviewcom.vue?vue&type=script&lang=js"

import "./InstgramReelreviewcom.vue?vue&type=style&index=0&id=7b8b2201&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b8b2201"]])

export default __exports__